'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Radio = function (_React$Component) {
    _inherits(Radio, _React$Component);

    function Radio(props) {
        _classCallCheck(this, Radio);

        var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));

        _this.onSelectionChanged = function (e) {
            _this.setState({
                selected: e.currentTarget.value
            }, function () {
                _this.props.callbackParent([_this.state.selected]);
            });
        };

        _this.getDataRowFromRadioData = function () {
            var optionKeys = [];

            if (_this.props.radioData.options) {

                optionKeys = _this.props.radioData.options.map(function (option) {
                    return _lodash2.default.keys(option)[0];
                });
            } else {
                var filteredData = _lodash2.default.omit(_this.props.radioData, ['category', 'minChoose', 'maxChoose', 'required', 'allowOptionQty']);

                optionKeys = _lodash2.default.keys(filteredData);
            }

            return optionKeys;
        };

        _this.getOptionObject = function (option) {
            var radioData = _this.props.radioData;
            var optionObject = null;

            if (radioData.options) {
                optionObject = radioData.options.find(function (x) {
                    return _lodash2.default.keys(x)[0] === option;
                });
            }

            return optionObject;
        };

        _this.isOptionOos = function (option, optionObject) {
            var isOptionOos = false;

            if (optionObject) {
                isOptionOos = optionObject[option].oos;
            }

            return isOptionOos;
        };

        _this.getExtraCost = function (option, optionObject) {
            var radioData = _this.props.radioData;
            var extraCost = '';

            if (radioData.options) {
                extraCost = optionObject[option].price === 0 ? '' : '+ $' + optionObject[option].price;
            } else {
                extraCost = radioData[option] === 0 ? '' : '+ $' + radioData[option];
            }

            return extraCost;
        };

        _this.state = {
            selected: ''
        };
        return _this;
    }

    _createClass(Radio, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            if (this.props.priorRadioData != null) {
                this.setState({
                    selected: this.props.priorRadioData[0]
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var category = this.props.radioData.category;
            var minChoose = this.props.radioData.minChoose;
            var maxChoose = this.props.radioData.maxChoose;
            var required = this.props.radioData.required;

            var optionKeys = this.getDataRowFromRadioData();

            var radioOptions = optionKeys.map(function (result, idx, array) {

                var optionObject = _this2.getOptionObject(result);
                var extraCost = _this2.getExtraCost(result, optionObject);
                var isOptionOos = _this2.isOptionOos(result, optionObject);

                var component = void 0;
                if (idx === 0 && required) {
                    component = _react2.default.createElement(
                        'div',
                        { className: ' ' + (isOptionOos ? 'disabled' : '') + ' padding-left-right radio-div', key: 'rd' + idx },
                        _react2.default.createElement(
                            'label',
                            { className: 'container-radio' },
                            result,
                            ' ',
                            extraCost,
                            ' ',
                            isOptionOos ? " [SOLD]" : '',
                            _react2.default.createElement('input', {
                                type: 'radio',
                                name: _this2.props.label,
                                key: _this2.props.label + idx,
                                value: result,
                                checked: _this2.state.selected === result,
                                onChange: _this2.onSelectionChanged,
                                disabled: isOptionOos,
                                required: true
                            }),
                            _react2.default.createElement('span', { className: 'checkmark-radio' })
                        )
                    );
                } else {
                    component = _react2.default.createElement(
                        'div',
                        { className: ' ' + (isOptionOos ? 'disabled' : '') + ' padding-left-right radio-div', key: 'rd' + idx },
                        _react2.default.createElement(
                            'label',
                            { className: 'container-radio' },
                            result,
                            ' ',
                            extraCost,
                            ' ',
                            isOptionOos ? " [SOLD]" : '',
                            _react2.default.createElement('input', {
                                type: 'radio',
                                name: _this2.props.label,
                                key: _this2.props.label + idx,
                                value: result,
                                checked: _this2.state.selected === result,
                                onChange: _this2.onSelectionChanged,
                                disabled: isOptionOos
                            }),
                            _react2.default.createElement('span', { className: 'checkmark-radio ' })
                        )
                    );
                }
                return component;
            });

            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    { className: this.props.cssClass },
                    this.props.label,
                    this.props.priorRadioData != null ? _react2.default.createElement(
                        'span',
                        { type: 'button', className: 'pull-right span-success' },
                        _react2.default.createElement('i', {
                            className: 'fa fa-check span-success-icon' }),
                        ' Required'
                    ) : _react2.default.createElement(
                        'span',
                        { type: 'button', className: 'pull-right span-warning' },
                        _react2.default.createElement('i', {
                            className: 'fa fa-warning span-warning-icon' }),
                        ' Required'
                    )
                ),
                radioOptions
            );
        }
    }]);

    return Radio;
}(_react2.default.Component);

exports.default = Radio;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Radio.jsx
// module id = 481
// module chunks = 0